import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const BookOpen = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      {/* <path
        d="M21 12C21 11.8218 20.5927 11.6545 19.8744 11.509C16.1554 10.7543 13.2476 7.84462 12.4911 4.12568C12.3456 3.40917 12.1783 3 12 3C11.8218 3 11.6545 3.40736 11.509 4.12568C10.7543 7.84462 7.84466 10.7525 4.12573 11.509C3.40922 11.6545 3.00004 11.8218 3.00004 12C3.00004 12.1782 3.4074 12.3455 4.12573 12.491C7.84466 13.2457 10.7525 16.1554 11.509 19.8743C11.6545 20.5908 11.8218 21 12 21C12.1783 21 12.3456 20.5926 12.4911 19.8743C13.2457 16.1554 16.1554 13.2475 19.8744 12.491C20.5909 12.3455 21 12.1782 21 12Z"
        {...mergedPathProps}
      /> */}
      <path
        d="M21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V21.5C2.45 20.4 4.55 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.45 20.4 15.55 20 17.5 20C18.67 20 19.89 20.15 21 20.5C21.75 20.75 22.4 21.05 23 21.5V6C22.4 5.55 21.75 5.25 21 5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z"
        {...mergedPathProps}
      />
      <path
        d="M17.5 10.5C18.38 10.5 19.23 10.59 20 10.76V9.24C19.21 9.09 18.36 9 17.5 9C15.8 9 14.26 9.29 13 9.83V11.49C14.13 10.85 15.7 10.5 17.5 10.5Z"
        {...mergedPathProps}
      />
      <path
        d="M13 12.4902V14.1502C14.13 13.5102 15.7 13.1602 17.5 13.1602C18.38 13.1602 19.23 13.2502 20 13.4202V11.9002C19.21 11.7502 18.36 11.6602 17.5 11.6602C15.8 11.6602 14.26 11.9602 13 12.4902Z"
        {...mergedPathProps}
      />
      <path
        d="M17.5 14.3301C15.8 14.3301 14.26 14.6201 13 15.1601V16.8201C14.13 16.1801 15.7 15.8301 17.5 15.8301C18.38 15.8301 19.23 15.9201 20 16.0901V14.5701C19.21 14.4101 18.36 14.3301 17.5 14.3301Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default BookOpen;
